import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-column.tsx
var LazyColumn = lazy(() => import("./column-DnnwwWIR.js").then((n) => n.n).then((module) => ({ default: module.Column })));
function Column({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "column" }),
		children: /* @__PURE__ */ jsx(LazyColumn, { ...props })
	});
}
function ColumnContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "column" }),
		children: /* @__PURE__ */ jsx(LazyColumn, { ...props })
	});
}
var useColumnContent = () => {
	return useMemo(() => ({ column: { component: ColumnContent } }), []);
};
//#endregion
export { Column, useColumnContent };
